/* eslint-disable @typescript-eslint/naming-convention */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { QPATResponse, UmsResponse } from 'qp-ui-interface';
import { isTokenExpired, manageResponse } from 'qp-utility';
import { map } from 'rxjs/operators';
import { LocalStorageKeys } from '../../LocalStorageKeys';
import { saveXAuthToken } from '../../utils/tokenUtils';
import { ConfigService } from '../config/config.service';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { DeviceHandlerService } from '../device-handler/device-handler.service';
import { isLoggedIn } from '../../utils/LoginUtils';
import { getXClientId } from '../../utils/deviceUtils';

@Injectable({
  providedIn: 'root',
})
export class QPATService {
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private deviceHandler: DeviceHandlerService,
    private localStorage: LocalStorageService
  ) {}

  getQPAT(): Promise<QPATResponse> {
    const headers = new HttpHeaders({
      accept: 'application/json',
      Authorization: `Bearer ${this.localStorage.getItem(LocalStorageKeys.AUTHDATA)}`,
      'Content-Type': 'application/json',
      'X-Client-Id': getXClientId(),
    });

    return this.http
      .post<UmsResponse>(
        `${this.configService.applicationConfig.qpatURL}`,
        {
          userId: this.localStorage.getItem(LocalStorageKeys.USER_ID),
          deviceId: this.deviceHandler.getCurrentDeviceID(),
          deviceInfo: this.deviceHandler.getXDeviceInfo(),
        },
        { headers }
      )
      .pipe(map((res) => manageResponse<QPATResponse>(res)))
      .toPromise();
  }

  async refreshXAuthToken(): Promise<void> {
    if (!isLoggedIn(this.localStorage)) {
      return Promise.resolve();
    }
    if (isTokenExpired(this.localStorage.getItem(LocalStorageKeys.XAUTH_TOKEN_EXP))) {
      const result = await this.getQPAT();
      saveXAuthToken(result, this.localStorage);
    }
  }
}
